import { useEffect, useState } from 'react';
import { calendarAPI } from '../api/client';

// Whether the user has at least one connected Google/Microsoft calendar —
// drives "Add to Calendar" vs "Added to calendar" on event rows. The result
// is cached module-wide (stale-while-revalidate) so several cards on one page
// don't each hit the connections endpoint, while a fresh connect made in
// Settings still shows up on the next page visit.
let cached: boolean | null = null;
let inflight: Promise<boolean> | null = null;

async function fetchConnected(): Promise<boolean> {
  if (!inflight) {
    inflight = calendarAPI
      .getConnections()
      .then((connections) => {
        cached = connections.some((c) => c.status === 'connected');
        return cached;
      })
      .catch(() => cached ?? false)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useCalendarConnected(): { connected: boolean; loading: boolean } {
  const [connected, setConnected] = useState(cached ?? false);
  const [loading, setLoading] = useState(cached === null);

  useEffect(() => {
    let cancelled = false;
    fetchConnected().then((value) => {
      if (!cancelled) {
        setConnected(value);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { connected, loading };
}
